var Grid = window.gridM.default;
Grid.define('zs-grid', 'revo-zs-grid', 'table');
